module.exports = __webpack_public_path__ + "img/partner.beeddfb8.png";